import type { Colors, DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  ...lightColors,
  primary: {
    lighten: '#5e77a9',
    default: '#4a5f8a',
    dim: 'rgba(74,95,138,0.4)',
    mute: 'rgba(74,95,138,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#dedfe2',
    '010': '#eaebee',
    main: '#f7f8fa',
    '020': '#f2f3f5',
    '030': '#e3e4e7',
    '040': '#d5d5d9',
    '050': '#cbccd0',
    '060': '#c1c2c6',
    '070': '#b5b6bb',
    '080': '#96969c',
    '090': '#65666e',
  },
  green: {
    lighten: '#3bb277',
    default: '#2e8c5d',
    dim: 'rgba(46,140,93,0.4)',
    mute: 'rgba(46,140,93,0.1)',
  },
  red: {
    lighten: '#c85964',
    default: '#b33b47',
    dim: 'rgba(179,59,71,0.4)',
    mute: 'rgba(179,59,71,0.1)',
  },
  yellow: {
    lighten: '#e3a71c',
    default: '#B68616',
    dim: 'rgba(182,134,22,0.4)',
    mute: 'rgba(182,134,22,0.1)',
  },
  orange: {
    lighten: '#ff6511',
    default: '#DD4E00',
    dim: 'rgba(221,78,0,0.4)',
    mute: 'rgba(221,78,0,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9f73d7',
    default: '#844BCC',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const LightScopeMarketsTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightSM',

  colorTextDefaultButton: '#000000',
  colorTextDefaultButtonHover: '#000000',
  colorTextDefaultButtonFocus: '#000000',
  colorTextDefaultButtonActive: '#000000',
  colorTextDefaultButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextPositiveButton: '#000000',
  colorTextPositiveButtonHover: '#000000',
  colorTextPositiveButtonFocus: '#000000',
  colorTextPositiveButtonActive: '#000000',
  colorTextPositiveButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextWarningButton: '#000000',
  colorTextWarningButtonHover: '#000000',
  colorTextWarningButtonFocus: '#000000',
  colorTextWarningButtonActive: '#000000',
  colorTextWarningButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextMutedButton: '#000000',
  colorTextMutedButtonHover: '#000000',
  colorTextMutedButtonFocus: '#000000',
  colorTextMutedButtonActive: '#000000',
  colorTextMutedButtonDisabled: 'rgba(0,0,0,0.5)',
});
